import React from 'react';
import { Button, Icon, Table, Form, Header, Segment, Popup, Loader, Grid } from 'semantic-ui-react';
import axios from 'axios';


import ReactExport from 'react-data-export';
import ReportExcelFile from './ReportExcelFile';
import { sanitizeExcelDataSet } from '../../util/sanitizeExcel';
import {
    additionalFilterSectionStyle,
    filterFieldGridStyle,
    shouldShowOrgUnitFilter
} from './reportUiHelpers';

const ExcelFile = ReportExcelFile;
const { ExcelSheet } = ReactExport.ExcelFile;

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

class StudyProgramPerCycle extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            active: [],
            archived: [],
            excelDataActive: [],
            excelDataArchived: [],
            organizationalUnitId: null,
            loader: false,
            reportRequested: false,

            orgUnitFilter: shouldShowOrgUnitFilter(localStorage.getItem('activeRole')),

        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getData = this.getData.bind(this);
    }
    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value,
            active: [],
            archived: [],
            excelDataActive: [],
            excelDataArchived: [],
            loader: false,
            reportRequested: false,
        });
    }

    getData() {
        const organizationalUnitId = this.state.organizationalUnitId || 0;

        const activeUrl = this.state.orgUnitFilter
            ? `reports/study-program-basic-count/for-admin/false/${organizationalUnitId}/`
            : 'reports/study-program-basic-count/false/';
        const archivedUrl = this.state.orgUnitFilter
            ? `reports/study-program-basic-count/for-admin/true/${organizationalUnitId}/`
            : 'reports/study-program-basic-count/true/';

        this.setState({ loader: true, reportRequested: true });
        Promise.all([axios.get(activeUrl), axios.get(archivedUrl)])
            .then(([activeRes, archivedRes]) => {
                this.setState({
                    loader: false,
                    active: activeRes.data,
                    archived: archivedRes.data,
                    excelDataActive: activeRes.data.map(el => ([
                        { value: el.studyCycleName },
                        { value: el.numberOfStudyProgramBasics }
                    ])),
                    excelDataArchived: archivedRes.data.map(el => ([
                        { value: el.studyCycleName },
                        { value: el.numberOfStudyProgramBasics }
                    ]))
                });
            })
            .catch(() => {
                this.setState({ loader: false });
            });
    }

    render() {
        const { loader, reportRequested } = this.state;
        const multiDataSet = [
            {
                columns: [
                    { title: 'Ciklus studija', width: { wpx: 200 } },
                    { title: 'Broj studijskih programa', width: { wpx: 200 } },

                ],
                data: this.state.excelDataActive,
            }
        ];

        const multiDataSet1 = [
            {
                columns: [
                    { title: 'Ciklus studija', width: { wpx: 200 } },
                    { title: 'Broj studijskih programa', width: { wpx: 200 } },

                ],
                data: this.state.excelDataArchived,
            }
        ];
        return (
            <div>
                <Form>
                    {this.state.orgUnitFilter && (
                        <Segment style={additionalFilterSectionStyle}>
                            <Header as="h4" color="blue">Dodatni filteri</Header>
                            <Form.Group widths="equal" style={filterFieldGridStyle}>
                                <Form.Field>
                                    <Form.Dropdown
                                        clearable
                                        label="Organizaciona jedinica"
                                        placeholder="Organizaciona jedinica"
                                        value={this.state.organizationalUnitId}
                                        onChange={this.handleInputChange}
                                        name="organizationalUnitId"
                                        options={this.props.organizationalUnits}
                                        search
                                        fluid
                                        selection
                                        error={this.state.organizationalUnitEntityError}
                                    />
                                </Form.Field>
                                <Form.Field />
                            </Form.Group>
                        </Segment>
                    )}
                    <Button basic="true" color="blue" floated="right" onClick={this.props.closeReport}>
                        Odustani
                    </Button>
                    <Button
                        color="blue"
                        floated="right"
                        onClick={this.getData}
                    >
                        Prikaži izvještaj
                    </Button>
                </Form>

                <br /><br /><br />

                {reportRequested && (loader ? <div><Loader active inline="centered" > Učitavanje podataka može potrajati, molimo da sačekate.</Loader><br /><br /><br /></div>
                    : <div>
                    {this.state.active.length ? <Table celled selectable compact>

                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={9} >
                                    <Grid column={2} stackable>
                                        <Grid.Column width={14}>
                                            <h3>Aktivni studijski programi</h3>
                                            {/* <SearchTableData profMozilla data={this.state.students} getResults={this.getResults} filterItem={['studyCycleName', 'numberOfStudyProgramBasics']} /> */}
                                        </Grid.Column>
                                        <Grid.Column width={2} textAlign="center">
                                            <ExcelFile
                                                filename="Broj aktivnih studijskih programa po ciklusu"
                                                element={<Popup
                                                    trigger={<Button animated="vertical" color="green" basic floated="right" fluid style={{ textAlign: 'center' }}>
                                                        <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                        <Button.Content visible>
                                                            Excel
                                                        </Button.Content>
                                                    </Button>}
                                                    content="Preuzmi spisak u Excel-u"
                                                    hideOnScroll
                                                    position="top center"
                                                />}
                                            >
                                                <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name="Studijski programi" />
                                            </ExcelFile>
                                        </Grid.Column>
                                    </Grid>
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell width="1">  R.br. </Table.HeaderCell>
                                <Table.HeaderCell colSpan={4}>Ciklus studija</Table.HeaderCell>
                                <Table.HeaderCell colSpan={4}> Broj studijskih programa </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {this.state.active.map((el, index) =>
                            (<Table.Row key={el.id}>

                                <Table.Cell verticalAlign="middle" width="1"> {index + 1}. </Table.Cell>
                                <Table.Cell colSpan={4} verticalAlign="middle" > {el.studyCycleName} </Table.Cell>
                                <Table.Cell colSpan={4} verticalAlign="middle" > {el.numberOfStudyProgramBasics}</Table.Cell>
                            </Table.Row>))}
                        </Table.Body>
                    </Table> : 'Nema aktivnih studijskih programa.'
                    }
                    <br />

                    {this.state.archived.length ? <Table celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={9} >
                                    <Grid column={2} stackable>
                                        <Grid.Column width={14}>
                                            <h3>Arhivirani studijski programi</h3>
                                            {/* <SearchTableData profMozilla data={this.state.students} getResults={this.getResults} filterItem={['studyCycleName', 'numberOfStudyProgramBasics']} /> */}
                                        </Grid.Column>
                                        <Grid.Column width={2} textAlign="center">
                                            <ExcelFile
                                                filename="Broj arhiviranih studijskih programa po ciklusu"
                                                element={<Popup
                                                    trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                        <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                        <Button.Content visible>
                                                            Excel
                                                        </Button.Content>
                                                    </Button>}
                                                    content="Preuzmi spisak u Excel-u"
                                                    hideOnScroll
                                                    position="top center"
                                                />}
                                            >
                                                <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet1)} name="Studijski programi" />
                                            </ExcelFile>
                                        </Grid.Column>
                                    </Grid>
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell width="1">  R.br. </Table.HeaderCell>
                                <Table.HeaderCell colSpan={4}>Ciklus studija</Table.HeaderCell>
                                <Table.HeaderCell colSpan={4}> Broj studijskih programa </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {this.state.archived.map((el, index) =>
                            (<Table.Row key={el.id}>

                                <Table.Cell verticalAlign="middle" width="1"> {index + 1}. </Table.Cell>
                                <Table.Cell colSpan={4} verticalAlign="middle" > {el.studyCycleName} </Table.Cell>
                                <Table.Cell colSpan={4} verticalAlign="middle" > {el.numberOfStudyProgramBasics}</Table.Cell>
                            </Table.Row>))}
                        </Table.Body>
                    </Table> : 'Nema arhiviranih studijskih programa.'}
                </div>)}
            </div>
        );
    }
}

export default StudyProgramPerCycle;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/StudyProgramPerCycle.js